import firebase from 'firebase/app'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCNd-2veqrbzWkPByWuFKmXWZvYiISGxCA",
    authDomain: "geo-ninjas-a6435.firebaseapp.com",
    databaseURL: "https://geo-ninjas-a6435.firebaseio.com",
    projectId: "geo-ninjas-a6435",
    storageBucket: "geo-ninjas-a6435.appspot.com",
    messagingSenderId: "499294817877"
};

const firebaseApp = firebase.initializeApp(config);

export default firebaseApp.firestore()